import { DropdownList } from '@cpm-pr1618001/ng-design-lib';

export const USER_DROPDOWN_LIST: DropdownList[] = [
  {
    id: 0,
    value: '',
    label: '',
    type: 'PROFILE',
  },
  {
    id: 1,
    value: '/dashboard/home',
    label: 'Home',
    type: 'TEXT',
    isSelected: true,
  },
  {
    id: 2,
    value: '',
    label: '',
    type: 'DIVIDER',
  },
  {
    id: 3,
    value: '/account/notifications',
    label: 'Notifications',
    type: 'TEXT',
  },
  {
    id: 4,
    value: '/account/messages',
    label: 'Messages',
    type: 'TEXT',
  },
  {
    id: 5,
    value: '/settings/profile',
    label: 'Account Settings',
    type: 'TEXT',
  },
  {
    id: 6,
    value: '',
    label: '',
    type: 'DIVIDER',
  },
  {
    id: 7,
    value: '/support/help',
    label: 'Help',
    type: 'TEXT',
  },
  {
    id: 8,
    value: '',
    label: '',
    type: 'DIVIDER',
  },
  {
    id: 9,
    value: '',
    label: 'Logout',
    type: 'TEXT',
  },
];
